import Lang from "@/common/Lang";
import moment from "moment/moment";
import { defineComponent, reactive, toRaw, UnwrapRef } from 'vue';

export default {
  methods: {
    convertPascalCase(title) {
      return title.replace(/(^\w|-\w)/g, function (text) {
        return text.replace(/-/, "").toUpperCase();
      });
    },
    generateRules(entity, fields) {
      let rules = {};
      for (let idx in fields) {
        let field = fields[idx];
        rules[field.name] = [];
        if (typeof field.validator != "undefined") {
          rules[field.name].push({
            validator: field.validator,
            trigger: field.trigger || "blur",
          });
        } else {
          if (typeof field.required != "undefined") {
            rules[field.name].push({
              required: true,
              message: window.__t('js.vui_long_nhap_field', { field: Lang[entity].attribute[field.name] }),
              trigger: field.trigger || "blur",
            });
          }
          if (typeof field.min != "undefined") {
            rules[field.name].push({
              min: window.__t('js.do_dai_field_toi_thieu_la_min', { field: Lang[field.name], min: field.min }),
              max: window.__t('js.do_dai_field_toi_da_la_max', { field: Lang[field.name], max: field.max }),
              trigger: field.trigger || "blur",
            });
          }
        }
      }
      return reactive(rules);
    },
    generateFormData(config) {
      let data = {};
      for (let prop in config) {
        let element = config[prop];
        data[prop] = "";
        switch (element.dataType) {
          case "array":
            data[prop] = [];
            break;
          case "number":
            data[prop] = 0;
            if (typeof element.defaultValue != "undefined") {
              data[prop] = element.defaultValue;
            }
            break;
          case "date":
            data[prop] = null;
            if (element.defaultValue === "now") {
              let increment = element.increment || 0;
              data[prop] = moment().add(increment, "days");
            }
            break;
          case "bool":
            data[prop] = null;
            if (element.defaultValue === false) {
              data[prop] = false;
            }
            break;
          case "time":
            data[prop] = null;
            if (element.defaultValue === "now") {
              data[prop] = moment();
            }
            break;
        }
        if (element.relation) {
          data[element.relation] = void 0;
        }
      }

      return reactive(data);
    },
  },
};
